// @flow
import * as React from 'react';
import styled from 'styled-components';

const Container = styled.div`
	height: 70px;
	width: 25px;
	background-color: rgba(0,58,49,0.1);
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const Round = styled.div`
	transform: rotate(-90deg);
	color: #4A4A4A;
	white-space: nowrap;
	font-size: 10px;
`;

type Props = {
	round_id: number
}

const RoundPanel = ({ round_id }: Props) =>
	<Container id={`R-${round_id}`}>
		<Round>RD{round_id}</Round>
	</Container>;

export default RoundPanel;


// WEBPACK FOOTER //
// ./src/components/MatchCentreBar/RoundPanel.js